import React, { useState } from "react";
import { api, formatErr } from "../lib/api";
import { Mail, Send } from "lucide-react";
import { toast } from "sonner";

export default function NewsletterForm({ inline = false, source = "footer" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sub, setSub] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email, source });
      toast.success(data.message || "Berlangganan berhasil");
      setSub(true);
    } catch (err) { toast.error(formatErr(err.response?.data?.detail) || "Gagal berlangganan"); }
    finally { setLoading(false); }
  };

  if (sub) return (
    <div className={`flex items-center gap-2 ${inline ? "text-sm" : "text-white"}`} data-testid="newsletter-subscribed">
      <Mail className="w-4 h-4" />
      <span>Terima kasih sudah berlangganan!</span>
    </div>
  );

  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2 max-w-md" data-testid="newsletter-form">
      <input
        type="email" required value={email} onChange={e => setEmail(e.target.value)}
        placeholder="email@kamu.com"
        className={`flex-1 px-4 py-3 rounded-full text-sm outline-none ${inline ? "border border-[#E2DFED] focus:border-[#6B4BA3]" : "bg-white/10 border border-white/20 text-white placeholder:text-white/60 backdrop-blur"}`}
        data-testid="newsletter-email"
      />
      <button disabled={loading}
        className={inline ? "lumina-btn-primary !py-3 !px-5" : "bg-white text-[#6B4BA3] hover:bg-[#E8F0FA] rounded-full px-6 py-3 font-medium text-sm transition-colors flex items-center justify-center gap-2"}
        data-testid="newsletter-submit"
      >
        <Send className="w-4 h-4" /> {loading ? "..." : "Daftar"}
      </button>
    </form>
  );
}
